import Layout from '@/components/Layout';
import client from '@/config/sanityClient';
import { useState, useEffect } from 'react';

import {
  TitleContainer,
  QuoteRow,
  QuoteColumn,
  hasImage,
  hasQuote,
} from '@/components/Learning';

function TeachingPage({ APIpictures, APIquotes }: any) {
  const [images, setImages]: any = useState([]);
  const [quotes, setQuotes]: any = useState([]);

  useEffect(() => {
    APIpictures && setImages(APIpictures);
    APIquotes && setQuotes(APIquotes);
  }, [APIpictures, APIquotes]);

  return (
    <Layout
      title={'Neville Goddard - relationships'}
      description={'Explanation on manifesting relationships'}
    >
      <TitleContainer>
        <h2>Neville Goddard</h2>
        <h1>RELATIONSHIPS</h1>
      </TitleContainer>
      <QuoteRow>
        <QuoteColumn>{hasQuote(quotes, 0)}</QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn>{hasImage(images, 1, 'long')}</QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn>{hasQuote(quotes, 1)}</QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn>{hasImage(images, 0, 'long')}</QuoteColumn>
      </QuoteRow>
      <QuoteRow></QuoteRow>
      <QuoteRow></QuoteRow>
    </Layout>
  );
}

export default TeachingPage;

export async function getStaticProps() {
  const picturesQuery = `*[_type == 'picture' && theme->name == 'relationships' ]{
    description,
    'imageUrl': picture.asset->url
  }`;
  const quotesQuery = `*[_type == 'quote' && theme->name == 'relationships' ]{
    teacher->{name},
    book->{name},
    content
  }`;
  const APIpictures = await client.fetch(picturesQuery);
  const APIquotes = await client.fetch(quotesQuery);
  return {
    props: {
      APIpictures,
      APIquotes,
    },
  };
}
